import { render, staticRenderFns } from "./upmarker.vue?vue&type=template&id=522b4bc9&scoped=true&"
import script from "./upmarker.vue?vue&type=script&lang=js&"
export * from "./upmarker.vue?vue&type=script&lang=js&"
import style0 from "./upmarker.vue?vue&type=style&index=0&id=522b4bc9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b4bc9",
  null
  
)

export default component.exports